import React, { useEffect, useState } from "react";
import { gsap } from "gsap";
import { data } from "./data";
import "./css/project.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
// import transition from "./Transition";

const ExampleComponent = ({ itemImg }) => (
  <div className="img-container">
    <img src={itemImg} alt="Item" id="item-img" />
  </div>
);

const ProjectPage = () => {
  const [itemImg, setItemImg] = useState("");

  useEffect(() => {
    const tl = gsap.timeline({ paused: true, overwrite: "auto" });

    tl.to(".overlay", {
      duration: 0.5,
      bottom: "0px",
      rotation: 0,
      transformOrigin: "bottom center",
      ease: "power3.inOut",
    });

    const handleItemClick = (index) => {
      updateOverlay(data[index]);
      tl.play();
    };

    const handleCloseClick = () => {
      tl.reverse();
    };

    const handleDocumentClick = (e) => {
      const overlay = document.querySelector(".overlay");
      if (overlay && !overlay.contains(e.target) && !isItem(e.target)) {
        tl.reverse();
      }
    };

    document.querySelectorAll(".item").forEach((item, index) => {
      item.addEventListener("click", () => handleItemClick(index));
    });

    document
      .querySelector("#close-btn")
      .addEventListener("click", handleCloseClick);
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.querySelectorAll(".item").forEach((item, index) => {
        item.removeEventListener("click", handleItemClick);
      });
      const closeButton = document.querySelector("#close-btn");
      if (closeButton) {
        closeButton.removeEventListener("click", handleCloseClick);
      }
      const overlay = document.querySelector(".overlay");
      if (overlay) {
        overlay.removeEventListener("click", handleDocumentClick);
      }
    };
  }, []);

  const isItem = (target) => {
    return target.closest(".item");
  };

  const updateOverlay = (dataItem) => {
    setItemImg(dataItem.itemImg);
    document.querySelector(
      "#item-category"
    ).previousElementSibling.textContent = dataItem.itemName;
    document.querySelector("#item-category").textContent =
      dataItem.itemCategory;
    document.querySelector("#item-link").href = dataItem.itemLink;
    document.querySelector("#item-copy").textContent = dataItem.itemCopy;
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {" "}
      <motion.div
        className="slide-in"
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 0 }}
        exit={{ scaleY: 1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      ></motion.div>
      <motion.div
        className="slide-out"
        initial={{ scaleY: 1 }}
        animate={{ scaleY: 0 }}
        exit={{ scaleY: 0 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      ></motion.div>
      <div className="body">
        <div className="nav">
          <p>
            <Link to="/">
              {" "}
              <span className="back-btn">
                <svg
                  viewBox="0 -6.5 36 36"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  fill="#000000"
                  width="15px"
                  strokeWidth="2" // Adjust this value to thicken the lines
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <title>left-arrow</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="icons"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="ui-gambling-website-lined-icnos-casinoshunter"
                        transform="translate(-342.000000, -159.000000)"
                        fill="#f5f5f5"
                        fillRule="nonzero"
                      >
                        <g
                          id="square-filled"
                          transform="translate(50.000000, 120.000000)"
                        >
                          <path
                            d="M317.108012,39.2902857 L327.649804,49.7417043 L327.708994,49.7959169 C327.889141,49.9745543 327.986143,50.2044182 328,50.4382227 L328,50.5617773 C327.986143,50.7955818 327.889141,51.0254457 327.708994,51.2040831 L327.6571,51.2479803 L317.108012,61.7097143 C316.717694,62.0967619 316.084865,62.0967619 315.694547,61.7097143 C315.30423,61.3226668 315.30423,60.6951387 315.694547,60.3080911 L324.702666,51.3738496 L292.99947,51.3746291 C292.447478,51.3746291 292,50.9308997 292,50.3835318 C292,49.8361639 292.447478,49.3924345 292.99947,49.3924345 L324.46779,49.3916551 L315.694547,40.6919089 C315.30423,40.3048613 315.30423,39.6773332 315.694547,39.2902857 C316.084865,38.9032381 316.717694,38.9032381 317.108012,39.2902857 Z M327.115357,50.382693 L316.401279,61.0089027 L327.002151,50.5002046 L327.002252,50.4963719 L326.943142,50.442585 L326.882737,50.382693 L327.115357,50.382693 Z"
                            id="left-arrow"
                            transform="translate(310.000000, 50.500000) scale(-1, 1) translate(-310.000000, -50.500000) "
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                Previous
              </span>
            </Link>
          </p>
          <p>
            <a
              className="Practice-btn"
              href="https://broseey.github.io/fun-projects-hub/"
              title="subtle fun parts of my projects"
              target="_blank"
              rel="noopener noreferrer"
            >
              Highlights
            </a>
          </p>
        </div>

        <div className="footer">
          <p>Broseey 2023 &copy;</p>
        </div>

        <div className="overlay">
          <div className="overlay-header">
            <div className="cols">
              <h1 id="item-name">Item name</h1>
              <p id="item-category">Item Category</p>
            </div>
            <div className="cols">
              <p id="close-btn">Close</p>
            </div>
          </div>
          <div className="item-details">
            <p>
              <i className="ph-bold ph-arrow-up-right"></i>
              <Link id="item-link" target="_blank">
                View Site
              </Link>
            </p>
            <p id="item-copy">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              Aspernatur, perferendis impedit ut a beatae ducimus vitae
              voluptatibus dolorum optio asperiores quos! Repellendus id
              doloribus facere sint reiciendis natus quos a!
            </p>
          </div>
          <ExampleComponent itemImg={itemImg} />
        </div>

        <div className="container-project">
          <div className="items">
            <div className="item">
              <div className="item-index">01</div>
              <div className="item-name">Convoservice Transport Nigeria</div>
              <div className="item-year">2023</div>
            </div>
            <div className="item">
              <div className="item-index">02</div>
              <div className="item-name">Royale Real Estate</div>
              <div className="item-year">2023</div>
            </div>
            <div className="item">
              <div className="item-index">03</div>
              <div className="item-name">Designer Emmax's Portfolio</div>
              <div className="item-year">2023</div>
            </div>

            <div className="item">
              <div className="item-index">04</div>
              <div className="item-name">Aesthetic Gallery </div>
              <div className="item-year">2023</div>
            </div>
            <div className="item">
              <div className="item-index">05</div>
              <div className="item-name">Favorite Musician Catalogue</div>
              <div className="item-year">2023</div>
            </div>
            <div className="item">
              <div className="item-index">06</div>
              <div className="item-name">Practice Project Highlights</div>
              <div className="item-year">2023</div>
            </div>
            <div className="item">
              <div className="item-index">07</div>
              <div className="item-name">Brief Work Showcase Site</div>
              <div className="item-year">2023</div>
            </div>
            <div className="item">
              <div className="item-index">08</div>
              <div className="item-name">Portfolio Demo Scroll effect</div>
              <div className="item-year">2022</div>
            </div>
            <div className="item">
              <div className="item-index">09</div>
              <div className="item-name">Portfolio Site Demo </div>
              <div className="item-year">2021</div>
            </div>
            <div className="item">
              <div className="item-index">10</div>
              <div className="item-name">Brose's JavaScript Basic Intro</div>
              <div className="item-year">2020</div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectPage;
